import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged, ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import { v4 as uuidv4 } from 'uuid';
import {
  AttributeBoolValueChanged,
  CancelAttributeAddition,
  ClearAttributeDateValue,
  DayOffsetValueChanged,
  DeleteAttributeRow,
  ExistingAttributeDateChanged,
  ExistingBoolAttributeChanged,
  LoadAttributes,
  MerchantAddAttribute,
  MerchantAttributesSuccess,
  NewAttributeDateChanged,
  PanelStateChanged,
  SaveAttribute,
  SaveValidAttribute,
  SelectedCodeChanged,
  SelectedTypeChanged,
  SelectedValueChanged,
  StringTableChanged,
} from '../actions/other.actions';
import { MerchantOtherState } from '../models/merchant.model';

const initialState: MerchantOtherState = {
  otherPanelExpanded: false,
  displayedColumns: {},
  grid: '',
  attributesLoaded: false,
  attributes: {},
  selectedCode: '',
  selectedType: '',
  selectedValue: '',
  attributeDate: new Date(0),
  attributeDateText: '',
  dayOffsetValues: ['Day Start (00:00:00)', 'Day End (23:59:59)'],
  dayOffsetValue: 'Day Start (00:00:00)',
  attributeBoolValue: false,
  addAttribute: false,
  saveAttribute: false,
};

export const MerchantOtherReducer = createReducer(
  initialState,
  on(MerchantAttributesSuccess, (state, { res }) => ({
    ...state,
    attributes: res,
  })),
  on(PanelStateChanged, (state) => ({
    ...state,
    attributesLoaded: state.otherPanelExpanded ? true : false,
    otherPanelExpanded: !state.otherPanelExpanded,
  })),
  on(LoadAttributes, (state, { res }) => {
    let grid: any = res;
    grid = grid.map(
      (attribute: { attributeName: string; attributeValue: string; dataType: string }) => ({
        ...attribute,
        id: uuidv4(),
      }),
    );
    return {
      ...state,
      displayedColumns: {
        Type: 'dataType',
        Code: 'attributeName',
        Value: 'attributeValue',
        Action: 'delete',
      },
      grid,
      attributesLoaded: true,
    };
  }),
  on(MerchantAddAttribute, (state) => ({
    ...state,
    addAttribute: true,
  })),
  on(CancelAttributeAddition, (state) => ({
    ...state,
    addAttribute: false,
    selectedCode: '',
    selectedType: '',
    selectedValue: '',
    attributeDate: new Date(0),
    attributeDateText: '',
    attributeBoolValue: false,
    saveAttribute: false,
    dayOffsetValue: 'Day Start (00:00:00)',
  })),
  on(DeleteAttributeRow, (state, { id }) => ({
    ...state,
    grid: state.grid.filter(
      (attribute: {
        attributeName: string;
        attributeValue: string;
        dataType: string;
        id: string;
      }) => attribute.id !== id,
    ),
  })),
  on(SelectedTypeChanged, (state, { selectedType }) => ({
    ...state,
    selectedType,
    selectedCode: '',
    selectedValue: '',
    attributeDate: new Date(0),
    attributeDateText: '',
    attributeBoolValue: false,
    dayOffsetValue: 'Day Start (00:00:00)',
  })),
  on(SelectedCodeChanged, (state, { selectedCode }) => ({
    ...state,
    selectedCode,
    selectedValue: '',
    attributeDate: new Date(0),
    attributeDateText: '',
    attributeBoolValue: false,
    dayOffsetValue: 'Day Start (00:00:00)',
  })),
  on(SelectedValueChanged, (state, { selectedValue }) => ({
    ...state,
    selectedValue,
  })),
  on(NewAttributeDateChanged, (state, { attributeDate, attributeDateText }) => ({
    ...state,
    attributeDate,
    attributeDateText,
  })),
  on(DayOffsetValueChanged, (state, { dayOffsetValue }) => ({
    ...state,
    dayOffsetValue,
  })),
  on(AttributeBoolValueChanged, (state) => ({
    ...state,
    attributeBoolValue: !state.attributeBoolValue,
  })),
  on(ClearAttributeDateValue, (state) => ({
    ...state,
    attributeDate: new Date(0),
    attributeDateText: '',
  })),
  on(StringTableChanged, (state, { text, index }) => {
    let gridCopy: any = [...state.grid];
    gridCopy[index] = { ...gridCopy[index], attributeValue: text };
    return {
      ...state,
      grid: gridCopy,
    };
  }),
  on(ExistingAttributeDateChanged, (state, { attributeDateText, index }) => {
    let gridCopy: any = [...state.grid];
    gridCopy[index] = { ...gridCopy[index], attributeValue: attributeDateText };
    return {
      ...state,
      grid: gridCopy,
    };
  }),
  on(ExistingBoolAttributeChanged, (state, { index }) => {
    let gridCopy: any = [...state.grid];
    gridCopy[index] = {
      ...gridCopy[index],
      attributeValue: gridCopy[index].attributeValue === 'false' ? 'true' : 'false',
    };
    return {
      ...state,
      grid: gridCopy,
    };
  }),
  on(SaveAttribute, (state) => ({
    ...state,
    saveAttribute: true,
  })),
  on(SaveValidAttribute, (state) => {
    let gridCopy = [...state.grid];
    gridCopy.unshift({
      attributeName: state.selectedCode,
      attributeValue:
        state.selectedType === 'INTEGER' ||
        state.selectedType === 'STRING' ||
        state.selectedType === 'LIST'
          ? state.selectedValue
          : state.selectedType === 'BOOLEAN'
            ? state.attributeBoolValue
              ? 'true'
              : 'false'
            : state.attributeDateText,
      dataType: state.selectedType,
      id: uuidv4(),
    });
    return {
      ...state,
      grid: gridCopy,
    };
  }),
  on(ActiveComponentChanged, (state) => ({
    ...state,
    otherPanelExpanded: false,
    displayedColumns: {},
    grid: '',
    attributesLoaded: false,
    selectedCode: '',
    selectedType: '',
    selectedValue: '',
    addAttribute: false,
    saveAttribute: false,
  })),
  on(ResetStateFromRouter, () => ({
    ...initialState
  }))
);
